import * as moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { Form,Button, Col, Row } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';



class TablePesagem extends React.Component {

    constructor(props) {
        super(props);

        this.options = {
            sortIndicator: true,
            noDataText: 'Sem dados'
        };



        this.selectRowProp = {
            mode: 'radio',
            bgColor: '#c1f291',
            onSelect: props.handleRowSelect,
            clickToSelect: true,
            hideSelectColumn: true
        };
        this.actionsFormatter = this.actionsFormatter.bind(this);
        this.dataMovimentacaoFormatter = this.dataMovimentacaoFormatter.bind(this);


    }

    actionsFormatter = (cell, row, obj) => {
        let acoes = <div>

            {row.is_ativo ?
                <Button title="Finalizar" size="sm" variant='success' href={`pesagem/${row.id}`}> <span className="fa fa-balance-scale" /> </Button>
                :
                <> </>
            }
            <Button style={{ marginLeft: 10 }} title="Impressão Térmica" size="sm" variant='warning' onClick={this.props.handlePrintTermica ? () => { this.props.handlePrintTermica(row.id); } : null}> <span className="fa fa-print" /> </Button>

            <Button style={{ marginLeft: 10 }} title="Impressão Completa" size="sm" variant='info' href={`resumo-pesagem/${row.id}`}> <span className="fa fa-television" /> </Button>

            <Button style={{ marginLeft: 10 }} title="Excluir" size="sm" variant="danger" onClick={this.props.handleClickDelete ? () => { this.props.handleClickDelete(row.id); } : null}  > <span className="fa fa-trash" /> </Button>

            &nbsp;
        </div>
        return acoes;
    };



    dataMovimentacaoFormatter = (cell, row) => {
        return moment(row.data_saida ? row.data_saida : row.data_entrada).format('DD/MM/YY HH:mm');//`${movimentacao.data}`;
    }
    pesagemAvulsaFormatter = (cell, row) => {
        return row.is_avulsa ? 'Sim' : 'Não';
    }

    columns = [{
        dataField: 'id',
        text: 'Código',
        sort: true,
        filter: textFilter({
            placeholder: 'Consultar código de barras',  // custom the input placeholder
        })
    }, {
        dataField: 'placa_carro',
        text: 'Placa',
        sort: true,
        filter: textFilter({
            placeholder: 'Consultar Placa',  // custom the input placeholder
        })
    },
    {
        dataField: 'agricultor.fazenda',
        text: 'Fazenda',
        filter: textFilter({
            placeholder: 'Consultar fazenda',  // custom the input placeholder
        }),
        style: {
            width: '10%'
        }
    },
    {
        dataField: 'motorista.nome_completo',
        text: 'Transportadora',
        filter: textFilter({
            placeholder: 'Consultar motorista',  // custom the input placeholder
        })
    },
    {
        dataField: 'nome_motorista',
        text: 'Motorista',
        filter: textFilter({
            placeholder: 'Consultar motorista',  // custom the input placeholder
        })
    },
    {
        dataField: 'agricultor.nome_completo',
        text: 'Agricultor',
        filter: textFilter({
            placeholder: 'Consultar agricultor',  // custom the input placeholder
        }),
        style: {
            width: '20%'
        }
    },
    {
        dataField: 'produto.descricao',
        text: 'Produto',
        filter: textFilter({
            placeholder: 'Consultar produto',  // custom the input placeholder
        }),
        style: {
            width: '20%'
        }
    },
    {
        text: 'Tipo',
        // formatter: movimentacaoFormatter,
        dataField: 'tipo',

    }, {
        text: 'Data Operação',
        formatter: this.dataMovimentacaoFormatter,
        style: {
            width: '15%'
        }
    },
    {
        text: 'Avulsa',
        formatter: this.pesagemAvulsaFormatter,        
    },
    {
        text: 'Opções',
        formatter: this.actionsFormatter,
        style: {
            width: '20%'
        }
    }
    ];

    // let pagination = {};




    render() {
        return <>
            <Row>
                <Col className="text-right">
                    <Form.Check
                        checked={this.props.checked}
                        onChange={this.props.handleClickTodos}
                        type="switch"
                        id="custom-switch"
                        label="Finalizadas"
                    />
                </Col>

            </Row>
            <BootstrapTable pagination={ paginationFactory() } striped hover condensed keyField='id' data={this.props.pesagemObject.results ? this.props.pesagemObject.results : []} columns={this.columns} filter={filterFactory()} >

            </BootstrapTable>
        </>
    }

}

TablePesagem.propTypes = {
    pesagemObject: PropTypes.array.isRequired,
    handleClickEditar: PropTypes.func.isRequired,
    handleRowSelect: PropTypes.func.isRequired,
    handleClickDelete: PropTypes.func.isRequired
};

export default TablePesagem;
